import { render, staticRenderFns } from "./AddBulkQuiz.vue?vue&type=template&id=481af028"
import script from "./AddBulkQuiz.vue?vue&type=script&lang=js"
export * from "./AddBulkQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports